import React from 'react';

const WhatsAppFloat = () => {
    return (
        <a href="https://wa.link/erzrv5" className="whatsapp-float" target="_blank" rel="noreferrer">
            <i className="fab fa-whatsapp whatsapp-icon"></i>
        </a>
    );
};

export default WhatsAppFloat;
